import Rails from "@rails/ujs";

document.addEventListener('turbolinks:load', function() {
	const region_sel = document.getElementById('region_select');
	const region_div = document.getElementById('div_region_select');
	const model  = (region_div !== null) ? region_div.getAttribute('data-model-name') : 'accession';
	if (region_sel !== null) {
		region_sel.addEventListener('change', function() {
			Rails.ajax({
				url: "/countries/country_select?region="+region_sel.value+"&model_name="+model,
				type: "GET",
				success: function(data) {
					document.getElementById('country_select').innerHTML = data.getElementById('country_select').innerHTML;
				}
			});
		});
	}
});
